import {SummaryModel} from "../../../../../common/entity/summary.model";
import {PermissionsModel} from "../../../../../common/entity/permissions.model";

export class CamMachineSummaryModel implements SummaryModel {
    id: number;
    permissions: PermissionsModel;
    name: string;
    label: string;
    remoteAccess = false;
    nbMaterials: number;
}